import { Module, ModuleOptionsValue } from '@/modules/companies/consts'
import { useTranslate } from '@ur-solutions/react-hooks'
import { ModuleOptionCards } from '../components/ModuleOptionCards'
import { BetaChip } from '../components/SalarySettings/generation-preview/beta-chip'
import { BetaPreviewHint } from '../components/SalarySettings/generation-preview/beta-preview-hint'
import { GenerationPreviewTool } from '../components/SalarySettings/generation-preview/generation-preview-tool'
import { GenerationModifiersSection } from '../components/SalarySettings/generation-rules/generation-modifiers-section'
import { GenerationRulesSection } from '../components/SalarySettings/generation-rules/generation-rules-section'
import { LegacyDietSection } from '../components/SalarySettings/generation-rules/legacy-diet-options'

export const DietSettings: React.FC = () => {
  const texts = useTranslate({
    title: 'settings.diet-settings',
    automaticDiets: 'settings.salary.automatic-diet-section',
    legacy: 'settings.diet-settings.legacy-calculation',
    legacyDescription: 'settings.diet-settings.legacy-company-description',
    rules: 'settings.generation-rules.title',
    rulesDescription: 'settings.diet-settings.rules-company-description',
  })

  return (
    <div className="flex flex-col gap-4 p-4">
      <h1 className="text-2xl font-semibold text-stone-900">{texts.title}</h1>

      <section className="overflow-hidden rounded-2xl bg-white shadow-card">
        <h2 className="px-5 pt-4 text-lg font-semibold text-stone-900">
          {texts.automaticDiets}
        </h2>
        <div className="flex flex-col gap-3 px-5 py-4">
          <h3 className="text-xs font-semibold uppercase text-stone-500">
            {texts.legacy}
          </h3>
          <p className="text-sm text-stone-600">{texts.legacyDescription}</p>
          <ModuleOptionCards
            module={Module.ACTIVITIES}
            includeOptions={[
              ModuleOptionsValue.ACTIVITIES_AUTOMATIC_DRIVER_DIET,
              ModuleOptionsValue.ACTIVITIES_AUTOMATIC_SALARY_DAYS,
            ]}
          />
        </div>
        <div className="flex flex-col gap-3 border-t border-stone-200 px-5 py-4">
          <div className="flex items-center gap-3">
            <h3 className="text-xs font-semibold uppercase text-stone-500">
              {texts.rules}
            </h3>
            <BetaChip />
          </div>
          <p className="text-sm text-stone-600">{texts.rulesDescription}</p>
          <BetaPreviewHint />
          <ModuleOptionCards
            module={Module.SALARY}
            includeOptions={[ModuleOptionsValue.SALARY_GENERATION_RULES]}
          />
        </div>
      </section>

      <LegacyDietSection />
      <GenerationRulesSection />
      <GenerationModifiersSection />
      <GenerationPreviewTool />
    </div>
  )
}
